import React, {Component, Fragment} from 'react';
import {Form, Input, InputGroup, Label, FormGroup, ButtonGroup, Button} from 'reactstrap';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Dialog from 'apa/containers/Dialog';
import Loading from 'apa/components/Loading';
import BootstrapTable from 'react-bootstrap-table-next';
import Date from 'apa/components/Date';
import {ChangeYear} from 'invoices/Options';
import {getToday} from 'invoices/containers/InvoiceDetail';
import * as time_sheets from 'customers/actions/time_sheets';

const rates = [
    'Grundbetreuung',
    'Fahrzeit',
    'Sonder',
    'Projekte',
    'Betriebsspezifisch'
];

@connect(
    null,
    dispatch => {
        return {
            remove: sheet => dispatch(time_sheets.remove(sheet))
        }
    }
)
export class DeleteTimeSheetModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleteWorkModalOpen: false
        }

    }

    render() {
        return (
            <Fragment>

                <Button color='danger' onClick={this.toggleDeleteModal}>
                    <i className='fa fa-trash'> </i>
                </Button>
                <Dialog
                    isOpen={this.state.isDeleteWorkModalOpen}
                    confirm={this.confirmDelete}
                    toggle={this.toggleDeleteModal}
                    title={'Stunden löschen'}
                >
                    Sind Sie sicher?
                </Dialog>
            </Fragment>
        )
    }

    @autobind
    confirmDelete() {
        this.props.remove(this.props.work);
        this.toggleDeleteModal()
        this.props.confirm()
    }

    @autobind
    toggleDeleteModal() {
        this.setState(
            {
                isDeleteWorkModalOpen: !this.state.isDeleteWorkModalOpen
            }
        )
    }
}

@connect(
    state => (
        {
            auth: state.apa
        }
    )
)
export class EditWorkModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            newTimeSheet: props.work,
            customer: props.customer
        }
    }

    @autobind
    toggle() {
        this.setState(
            {
                isOpen: !this.state.isOpen
            }
        )

    }

    @autobind
    confirm() {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        const body = JSON.stringify(
            this.state.newTimeSheet
        );
        fetch(
            `https://apabackend.quixtest.de/api/time_sheets/${this.state.newTimeSheet.id}/`,
            {headers, method: 'PATCH', body}
        ).then(
            res => res.json()
        ).then(
            work => {
                this.props.confirm(work);
                this.toggle();
            }
        );
    }

    @autobind
    handleSubmit(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({
            newTimeSheet: {
                ...this.state.newTimeSheet,
                [name]: value
            }

        })
    }

    render() {
        return (
            <Fragment>
                <Button color="primary" onClick={this.toggle}>
                    <i className='fa fa-edit'> </i>
                </Button>
                <Dialog
                    toggle={this.toggle}
                    confirm={this.confirm}
                    isOpen={this.state.isOpen}
                    title={'Arbeit bearbeiten'}
                >
                    <Form>
                        <FormGroup>
                            <Label>
                                Stunden
                            </Label>
                            <Input type="number" name="hours" step="0.1" value={this.state.newTimeSheet.hours}
                                   onChange={this.handleSubmit}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Stundensatz
                            </Label>
                            <Input type="select" name="rate" value={this.state.newTimeSheet.rate}
                                   onChange={this.handleSubmit}>
                                {
                                    rates.map((rate, idx) => (
                                        <option key={`rate_${idx}`} value={idx}>
                                            {rate}
                                        </option>
                                    ))
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Datum
                            </Label>
                            <Input type="date" name="date" value={this.state.newTimeSheet.date}
                                   onChange={this.handleSubmit}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Kommentar
                            </Label>
                            <Input type="textarea" name="comment" value={this.state.newTimeSheet.comment}
                                   onChange={this.handleSubmit}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Verrechnet
                            </Label>
                            <Input type="select" name="verrechnet" value={this.state.newTimeSheet.verrechnet}
                                   onChange={this.handleSubmit}>
                                <option value={0}>Nein</option>
                                <option value={1}>Ja</option>
                            </Input>
                        </FormGroup>
                    </Form>
                </Dialog>
            </Fragment>
        )
    }
}

@connect(
    state => {
        return {
            customers: state.customers,
            items: state.items
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            },
            add: (newWork) => dispatch(time_sheets.add(newWork))
        }
    }
)
export default class TimeSheet extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isEditModal:false,
            isLoading: true,
            customer: null,
            isNewWorkLogModalOpen: false,
            timeSheetList: [],
            newTimeSheet: {
                date: getToday(),
                hours: 0.0,
                rate: 0,
                comment: '',
                verrechnet: 0
            }
        };
    }

    componentDidMount() {
        this.fetchCustomer();
    }

    @autobind
    fetchCustomer() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id, customer => {
            this.setState(
                {
                    isLoading: false,
                    customer: customer,
                    timeSheetList: customer.time_sheets
                }
            )
        })
    }

    @autobind
    confirmEditWork(work) {
        this.setState(
            {
                isEditModal: true
            }
        )
        const index = this.state.timeSheetList.findIndex(w => w.id === work.id);
        const timeSheetList = [...this.state.timeSheetList];
        timeSheetList.splice(index, 1, work);
        this.setState({
            timeSheetList: timeSheetList
        })
    }

    @autobind
    deleteWork(work) {
        const index = this.state.timeSheetList.findIndex(w => w.id === work.id);
        const timeSheetList = [...this.state.timeSheetList];
        timeSheetList.splice(index, 1);
        this.setState({
            timeSheetList: timeSheetList
        })
    }


    render() {
        const id = this.props.match.params.id;
        if (this.state.isLoading)
            return <Loading/>;
        const customer = this.state.customer;
        const columnList = [
            {
                dataField: 'date',
                text: 'Datum',
                formatter: cell => <Date date={cell}/>
            },
            {
                dataField: 'hours',
                text: 'Stunden'
            },
            {
                dataField: 'price',
                text: 'Preis'
            },
            {
                dataField: 'comment',
                text: 'Kommentar'
            },
            {
                dataField: 'verrechnet',
                text: 'Verrechnet',
                formatter: cell => cell ? 'Ja' : 'Nein'
            },
            {
                dataField: 'id',
                text: '',
                isDummyField: true,
                formatter: (cell, row) =>
                    <ButtonGroup>
                        <EditWorkModal work={row} customer={customer} confirm={this.confirmEditWork}/>
                        <DeleteTimeSheetModal work={row} confirm={() => this.deleteWork(row)}/>
                    </ButtonGroup>
            }

        ];
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <InputGroup className="mb-3">
                    <Button color="primary" onClick={this.toggleNewWorkLog}>
                        Stunden hinzufügen
                    </Button>
                    <ChangeYear nolabel/>
                </InputGroup>
                <Dialog
                    toggle={this.toggleNewWorkLog}
                    confirm={this.confirmNewWorkLog}
                    isOpen={this.state.isNewWorkLogModalOpen}
                    title={'Stunden hinzufügen'}
                >
                    <Form onSubmit={this.confirmNewWorkLog}>
                        <FormGroup>
                            <Label>
                                Stunden
                            </Label>
                            <Input type="number" name="hours" step="0.1" value={this.state.newTimeSheet.hours}
                                   onChange={this.handleSubmit}/>
                            <small>
                                Beispiele:
                                <a onClick={
                                    () => this.setState(
                                    {
                                        newTimeSheet: {
                                            ...this.state.newTimeSheet,
                                            hours: 0.5
                                        }
                                    }
                                )
                                } href="#">0,5h</a> | <a onClick={
                                () => this.setState(
                                    {
                                        newTimeSheet: {
                                            ...this.state.newTimeSheet,
                                            hours: 1.0
                                        }
                                    }
                                )
                            } href="#">1,0h</a> | <a onClick={
                                () => this.setState(
                                    {
                                        newTimeSheet: {
                                            ...this.state.newTimeSheet,
                                            hours: 1.5
                                        }
                                    }
                                )
                            } href="#">1,5h</a>
                            </small>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Stundensatz
                            </Label>
                            <Input type="select" name="rate" value={this.state.newTimeSheet.rate}
                                   onChange={this.handleSubmit}>
                                {
                                    rates.map((rate, idx) => (
                                        <option key={`rate_${idx}`} value={idx}>
                                            {rate}
                                        </option>
                                    ))
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Datum
                            </Label>
                            <Input type="date" name="date" value={this.state.newTimeSheet.date}
                                   onChange={this.handleSubmit}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Kommentar
                            </Label>
                            <Input type="textarea" name="comment" value={this.state.newTimeSheet.comment}
                                   onChange={this.handleSubmit}/>
                        </FormGroup>
                        {
                            this.state.isEditModal && 
                            <FormGroup>
                                <Label>
                                    Verrechnet
                                </Label>
                                <Input type="select" name="verrechnet" value={this.state.newTimeSheet.verrechnet}
                                    onChange={this.handleSubmit}>
                                    <option value={0}>Nein</option>
                                    <option value={1}>Ja</option>
                                </Input>
                           </FormGroup>
                        }
                    </Form>
                </Dialog>
                <BootstrapTable
                    keyField='id'
                    data={this.state.timeSheetList}
                    columns={columnList}
                    bootstrap4
                    responsive
                />
            </DetailContainer>
        )
    }

    @autobind
    toggleNewWorkLog() {
        this.setState(
            {
                isNewWorkLogModalOpen: !this.state.isNewWorkLogModalOpen
            }
        )

    }

    @autobind
    confirmNewWorkLog() {
        this.props.add(
            {
                ...this.state.newTimeSheet,
                customer: this.state.customer.id
            }
        );
        this.setState({isLoading: true, isEditModal: false});
        setTimeout(
            ()=> {
                this.fetchCustomer();
                this.toggleNewWorkLog()
            }, 500)
    }

    @autobind
    handleSubmit(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({
            ...this.state,
            newTimeSheet: {
                ...this.state.newTimeSheet,
                [name]: value
            }
        })
    }
}

